import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box, Button, Card, CardContent, Typography, Chip, CircularProgress, Tabs, Tab,
  TextField, MenuItem, FormControl, InputLabel, Select, List, ListItem, ListItemText,
  IconButton, Checkbox, ListItemIcon, Paper, Dialog, DialogTitle, DialogContent,
  DialogActions, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Switch, FormControlLabel, Grid, Alert, Autocomplete, InputAdornment
} from '@mui/material';
import { ArrowBack, Edit, ContentCopy, Upload, Delete, Save, Cancel, Add, Link as LinkIcon, Download, Block, Search } from '@mui/icons-material';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

function CampaignDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState(null);
  const [partners, setPartners] = useState([]);
  const [selectedPartners, setSelectedPartners] = useState([]);
  const [offerUrls, setOfferUrls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [creatives, setCreatives] = useState([]);
  const [conversionEvents, setConversionEvents] = useState([]);
  const [openEventModal, setOpenEventModal] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);
  const [openOfferUrlModal, setOpenOfferUrlModal] = useState(false);
  const [editingOfferUrl, setEditingOfferUrl] = useState(null);
  const [openTrackingLinkModal, setOpenTrackingLinkModal] = useState(false);
  const [selectedPartnerForLink, setSelectedPartnerForLink] = useState('');
  const [selectedOfferUrlForLink, setSelectedOfferUrlForLink] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const [filteredPartners, setFilteredPartners] = useState(null);
  const [creativeFilter, setCreativeFilter] = useState('active');
  const [openCreativeModal, setOpenCreativeModal] = useState(false);
  const [creativeType, setCreativeType] = useState('html');
  const [creativeForm, setCreativeForm] = useState({ name: '', content: '' });
  const [openDownloadModal, setOpenDownloadModal] = useState(false);
  const [downloadCreative, setDownloadCreative] = useState(null);
  const [downloadPartner, setDownloadPartner] = useState('');
  const [downloadOfferUrl, setDownloadOfferUrl] = useState('');
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [previewCreative, setPreviewCreative] = useState(null);
  const [editingCreative, setEditingCreative] = useState(null);
  const [partnerPayout, setPartnerPayout] = useState(null);
  const [trackingDomains, setTrackingDomains] = useState([]);
  const [advertisers, setAdvertisers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [blacklistedPartners, setBlacklistedPartners] = useState([]);
  const [partnerPayouts, setPartnerPayouts] = useState({});
  const [emailItems, setEmailItems] = useState({ senders: [], subjects: [], preheaders: [] });
  const [newItemValue, setNewItemValue] = useState('');
  const [addingItemType, setAddingItemType] = useState(null);
  const [editingItem, setEditingItem] = useState(null);
const [editItemValue, setEditItemValue] = useState('');
  const [openPayoutModal, setOpenPayoutModal] = useState(false);
  const [editingPartnerPayout, setEditingPartnerPayout] = useState(null);
  const [partnerSearchAssign, setPartnerSearchAssign] = useState('');
  const [partnerSearchBlacklist, setPartnerSearchBlacklist] = useState('');
  const [downloadSourceId, setDownloadSourceId] = useState('');

  const { user, isPartner } = useAuth();
  const isPartnerRole = isPartner();

  const [formData, setFormData] = useState({
    name: '', revenue: '', payout: '', payout_type: 'fixed', payout_percentage: '',
    base_destination_url: '', description: '', tracking_type: 'postback',
    postback_url: '', pixel_code: '', daily_cap: '', countries: '', advertiser_id: '',
    cap_reached: false, requires_approval: false, tracking_domain_id: '', internal_notes: '', category_id: '',
  });

  const [eventForm, setEventForm] = useState({
    event_name: '', event_code: '', revenue_type: 'CPA', revenue_amount: '',
    payout_type: 'PRV', payout_amount: '', payout_percentage: '', postback_url: '',
    pixel_code: '', visibility: 'public', advertiser_event_name: '', is_Defaultdefault: false,
  });

  const [offerUrlForm, setOfferUrlForm] = useState({ name: '', url_template: '', is_default: false });

  useEffect(() => {
    fetchAll();
  }, [id]);

  useEffect(() => {
    if (!loading) fetchCreatives();
  }, [creativeFilter]);

 const fetchAll = async () => {
    setLoading(true);
    if (isPartnerRole) {
      await Promise.all([fetchCampaign(), fetchPartners(), fetchOfferUrls(), fetchEvents(), fetchCampaignPartners(), fetchCreatives(), fetchTrackingDomains(), fetchAdvertisers(), fetchEmailItems(), fetchPartnerPayout(), fetchCategories()]);
    } else {
      await Promise.all([fetchCampaign(), fetchPartners(), fetchOfferUrls(), fetchEvents(), fetchCampaignPartners(), fetchCreatives(), fetchTrackingDomains(), fetchAdvertisers(), fetchEmailItems(), fetchCategories()]);
    } 
    setLoading(false);
  };

  const fetchPartnerPayout = async () => {
    try {
      const res = await axios.get(`/admin/partners/${user.partner_id}/campaigns`);
      const campaigns = res.data.data || [];
      const thisCampaign = campaigns.find(c => c.campaign_id === parseInt(id));
      if (thisCampaign) {
        setPartnerPayout({
          custom_payout: thisCampaign.custom_payout,
          custom_payout_type: thisCampaign.custom_payout_type,
          default_payout: thisCampaign.payout,
          default_payout_type: thisCampaign.payout_type,
          payout_percentage: thisCampaign.payout_percentage
        });
      }
    } catch (e) { console.error(e); }
  };

  const fetchCampaign = async () => {
    try {
      const res = await axios.get(`/admin/campaigns/${id}`);
      const data = res.data;
      setCampaign(data);
       setFormData({
        name: data.name || '', revenue: data.revenue || '', payout: data.payout || '', payout_type: data.payout_type || 'fixed',
        payout_percentage: data.payout_percentage || '', base_destination_url: data.base_destination_url || '',
        description: data.description || '', tracking_type: data.tracking_type || 'postback',
        postback_url: data.postback_url || '', pixel_code: data.pixel_code || '',
        daily_cap: data.daily_cap || '', countries: data.countries ? data.countries.join(',') : '',
        advertiser_id: data.advertiser_id || '', cap_reached: data.cap_reached || false, requires_approval: data.requires_approval || false,
        tracking_domain_id: data.tracking_domain_id || '',
        internal_notes: data.internal_notes || '',
        category_id: data.category_id || '',
      });
    } catch (e) { console.error(e); }
  };

  const fetchPartners = async () => {
    try {
      const res = await axios.get('/admin/partners');
      setPartners(res.data.data || res.data || []);
    } catch (e) { console.error(e); }
  };

  const fetchTrackingDomains = async () => {
    try {
      const res = await axios.get('/admin/tracking-domains');
      setTrackingDomains(res.data.data || []);
    } catch (e) { console.error(e); }
  };

  const fetchAdvertisers = async () => {
    try {
      const res = await axios.get('/admin/advertisers');
      setAdvertisers((res.data.data || []).filter(a => a.status === 'active'));
    } catch (e) { console.error(e); }
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get('/admin/dem/maildome/categories');
      setCategories(res.data.data || []);
    } catch (e) { console.error(e); }
  };

  const fetchEmailItems = async () => {
    try {
      const res = await axios.get(`/admin/campaigns/${id}/email-items`);
      setEmailItems(res.data.data || { senders: [], subjects: [], preheaders: [] });
    } catch (error) { console.error('Error fetching email items:', error); }
  };

  const handleAddItem = async (itemType) => {
    if (!newItemValue.trim()) return;
    try {
      await axios.post(`/admin/campaigns/${id}/email-items`, { item_type: itemType, value: newItemValue.trim() });
      setNewItemValue('');
      setAddingItemType(null);
      fetchEmailItems();
    } catch (error) { setMessage({ type: 'error', text: 'Failed to add item' }); }
  };

  const handleDeleteItem = async (itemId) => {
    try {
      await axios.delete(`/admin/email-items/${itemId}`);
      fetchEmailItems();
    } catch (error) { setMessage({ type: 'error', text: 'Failed to delete item' }); }
  };

  const handleEditItem = async (item) => {
    setEditingItem(item);
    setEditItemValue(item.value);
  };

  const handleSaveEditItem = async () => {
    if (!editItemValue.trim() || !editingItem) return;
    try {
      await axios.put(`/admin/email-items/${editingItem.id}`, { value: editItemValue.trim() });
      setEditingItem(null);
      setEditItemValue('');
      fetchEmailItems();
    } catch (error) { setMessage({ type: 'error', text: 'Failed to update item' }); }
  };

  const handleCancelEdit = () => {
    setEditingItem(null);
    setEditItemValue('');
  };

  const getTrackingDomain = () => {
    const domain = trackingDomains.find(d => formData.tracking_domain_id ? d.id === Number(formData.tracking_domain_id) : d.is_primary);
    return domain?.domain || 'trcktoo.com';
  };

  const fetchCampaignPartners = async () => {
    try {
      const res = await axios.get(`/admin/campaigns/${id}/partners`);
      const data = res.data.data || res.data || [];
      const active = data.filter(p => p.status !== 'blacklisted');
      const blacklisted = data.filter(p => p.status === 'blacklisted');
      setSelectedPartners(active.map(p => p.partner_id));
      setBlacklistedPartners(blacklisted.map(p => p.partner_id));
      // Build payouts map
      const payouts = {};
      data.forEach(p => {
        if (p.custom_payout) {
          payouts[p.partner_id] = {
            custom_payout: p.custom_payout,
            custom_payout_type: p.custom_payout_type || 'fixed'
          };
        }
      });
      setPartnerPayouts(payouts);
    } catch (e) { console.error(e); }
  };

  const fetchOfferUrls = async () => {
    try {
      const res = await axios.get(`/admin/campaigns/${id}/offer-urls`);
      setOfferUrls(res.data.data || res.data || []);
    } catch (e) { console.error(e); }
  };

  const fetchEvents = async () => {
    try {
      const res = await axios.get(`/admin/campaigns/${id}/conversion-events`);
      setConversionEvents(res.data.data || res.data || []);
    } catch (e) { console.error(e); }
  };

  const handleSave = async () => {
    try {
      await axios.put(`/admin/campaigns/${id}`, { ...campaign, ...formData, revenue: parseFloat(formData.revenue || 0), payout: parseFloat(formData.payout) });
      setEditMode(false);
      setMessage({ type: 'success', text: 'Campaign updated!' });
      fetchCampaign();
    } catch (e) { setMessage({ type: 'error', text: 'Failed to update' }); }
  };


  const handleTogglePartner = async (partnerId) => {
    if (blacklistedPartners.includes(partnerId)) return;
    
    const newSelected = selectedPartners.includes(partnerId) 
      ? selectedPartners.filter(x => x !== partnerId) 
      : [...selectedPartners, partnerId];
    
    try {
      await axios.put(`/admin/campaigns/${id}/partners`, { 
        partner_ids: newSelected,
        payouts: partnerPayouts,
        blacklisted_ids: blacklistedPartners
      });
      setSelectedPartners(newSelected);
    } catch (e) {
      setMessage({ type: 'error', text: 'Failed to update partner' });
    }
  };

   const handleToggleBlacklist = async (partnerId) => {
    let newBlacklisted;
    let newSelected;
    
    if (blacklistedPartners.includes(partnerId)) {
      newBlacklisted = blacklistedPartners.filter(x => x !== partnerId);
      newSelected = selectedPartners;
    } else {
      newBlacklisted = [...blacklistedPartners, partnerId];
      newSelected = selectedPartners.filter(x => x !== partnerId);
    }
    
    try {
      await axios.put(`/admin/campaigns/${id}/partners`, { 
        partner_ids: newSelected,
        payouts: partnerPayouts,
        blacklisted_ids: newBlacklisted
      });
      setBlacklistedPartners(newBlacklisted);
      setSelectedPartners(newSelected);
    } catch (e) {
      setMessage({ type: 'error', text: 'Failed to update blacklist' });
    }
  };

  const handleOpenPayoutModal = (partner) => {
    setEditingPartnerPayout({
      partner_id: partner.partner_id,
      name: partner.name,
      custom_payout: partnerPayouts[partner.partner_id]?.custom_payout || '',
      custom_payout_type: partnerPayouts[partner.partner_id]?.custom_payout_type || 'fixed'
    });
    setOpenPayoutModal(true);
  };

  const handleSavePartnerPayout = async () => {
    const newPayouts = { ...partnerPayouts };
    if (editingPartnerPayout.custom_payout) {
      newPayouts[editingPartnerPayout.partner_id] = {
        custom_payout: editingPartnerPayout.custom_payout,
        custom_payout_type: editingPartnerPayout.custom_payout_type
      };
    } else {
      delete newPayouts[editingPartnerPayout.partner_id];
    }
    
    try {
      await axios.put(`/admin/campaigns/${id}/partners`, { 
        partner_ids: selectedPartners,
        payouts: newPayouts,
        blacklisted_ids: blacklistedPartners
      });
      setPartnerPayouts(newPayouts);
      setMessage({ type: 'success', text: 'Partner payout saved!' });
    } catch (e) {
      setMessage({ type: 'error', text: 'Failed to save payout' });
    }
    
    setOpenPayoutModal(false);
    setEditingPartnerPayout(null);
  };

  const handleSaveEvent = async () => {
    try {
      if (editingEvent) {
        await axios.put(`/admin/conversion-events/${editingEvent.event_id}`, { ...eventForm, status: 'active' });
      } else {
        await axios.post(`/admin/campaigns/${id}/conversion-events`, eventForm);
      }
      fetchEvents();
      setOpenEventModal(false);
      setMessage({ type: 'success', text: `Event ${editingEvent ? 'updated' : 'created'}!` });
    } catch (e) { setMessage({ type: 'error', text: 'Failed to save event' }); }
  };

  const handleDeleteEvent = async (eventId) => {
    if (window.confirm('Delete this event?')) {
      try {
        await axios.delete(`/admin/conversion-events/${eventId}`);
        fetchEvents();
      } catch (e) { console.error(e); }
    }
  };

  const handleSaveOfferUrl = async () => {
    try {
      if (editingOfferUrl) {
        await axios.put(`/admin/offer-urls/${editingOfferUrl.offer_url_id}`, { ...offerUrlForm, status: 'active' });
      } else {
        await axios.post(`/admin/campaigns/${id}/offer-urls`, offerUrlForm);
      }
      fetchOfferUrls();
      setOpenOfferUrlModal(false);
      setMessage({ type: 'success', text: `Offer URL ${editingOfferUrl ? 'updated' : 'created'}!` });
    } catch (e) { setMessage({ type: 'error', text: 'Failed to save' }); }
  };

  const handleDeleteOfferUrl = async (urlId) => {
    if (window.confirm('Delete this URL?')) {
      try {
        await axios.delete(`/admin/offer-urls/${urlId}`);
        fetchOfferUrls();
      } catch (e) { console.error(e); }
    }
  };

  const openEventEdit = (event = null) => {
    if (event) {
      setEditingEvent(event);
      setEventForm({ ...event });
    } else {
      setEditingEvent(null);
      // Auto-generate next event code
      const existingCodes = conversionEvents.map(e => parseInt(e.event_code)).filter(n => !isNaN(n));
      const nextCode = existingCodes.length > 0 ? Math.max(...existingCodes) + 1 : 1;
      setEventForm({ event_name: '', event_code: String(nextCode), revenue_type: 'CPA', revenue_amount: '', payout_type: 'PRV', payout_amount: '', payout_percentage: '', postback_url: '', pixel_code: '', visibility: 'public', advertiser_event_name: '', is_default: false });
    }
    setOpenEventModal(true);
  };

  const openOfferUrlEdit = (url = null) => {
    if (url) {
      setEditingOfferUrl(url);
      setOfferUrlForm({ name: url.name, url_template: url.url_template, is_default: url.is_default });
    } else {
      setEditingOfferUrl(null);
      setOfferUrlForm({ name: '', url_template: '', is_default: false });
    }
    setOpenOfferUrlModal(true);
  };

  const generateTrackingLink = () => {
    let link = `https://${getTrackingDomain()}/track?campaign_id=${id}`;
    if (isPartnerRole) {
      link += `&partner_id=${user.partner_id}`;
    } else if (selectedPartnerForLink) {
      link += `&partner_id=${selectedPartnerForLink}`;
    }
    if (selectedOfferUrlForLink) link += `&offer_url_id=${selectedOfferUrlForLink}`;
    return link;
  };

  const copyLink = () => {
    navigator.clipboard.writeText(generateTrackingLink());
    setMessage({ type: 'success', text: 'Link copied!' });
    setOpenTrackingLinkModal(false);
  };

  const calculatePayout = (ev) => {
    if (ev.payout_type === 'CPA') return `€${parseFloat(ev.payout_amount || 0).toFixed(2)}`;
    const calc = (parseFloat(ev.revenue_amount || 0) * parseFloat(ev.payout_percentage || 0)) / 100;
    return `${ev.payout_percentage}% (€${calc.toFixed(2)})`;
  };

  const fetchCreatives = async () => {
    try {
      const status = isPartnerRole ? 'active' : creativeFilter;
      const res = await axios.get(`/admin/campaigns/${id}/creatives?status=${status}`);
      setCreatives(res.data.data || []);
    } catch (e) { console.error(e); }
  };

  const handleSaveCreative = async () => {
    try {
      if (creativeType === 'html') {
        await axios.post(`/admin/campaigns/${id}/creatives`, {
          name: creativeForm.name,
          type: 'html',
          content: creativeForm.content
        });
      }
      fetchCreatives();
      setOpenCreativeModal(false);
      setCreativeForm({ name: '', content: '' });
      setMessage({ type: 'success', text: 'Creative added!' });
    } catch (e) { setMessage({ type: 'error', text: 'Failed to add creative' }); }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        await axios.post(`/admin/campaigns/${id}/creatives/upload`, {
          name: file.name.split('.')[0],
          imageData: reader.result,
          mimeType: file.type
        });
        fetchCreatives();
        setMessage({ type: 'success', text: 'Image uploaded!' });
      } catch (e) { setMessage({ type: 'error', text: 'Failed to upload' }); }
    };
    reader.readAsDataURL(file);
  };

  const handleDeleteCreative = async (creativeId) => {
    if (window.confirm('Move this creative to inactive?')) {
      try {
        await axios.put(`/admin/creatives/${creativeId}/status`, { status: 'inactive' });
        fetchCreatives();
        setMessage({ type: 'success', text: 'Creative moved to inactive!' });
      } catch (e) { setMessage({ type: 'error', text: 'Failed to update' }); }
    }
  };

  const handleToggleCreativeStatus = async (creative) => {
    const newStatus = creative.status === 'active' ? 'inactive' : 'active';
    try {
      await axios.put(`/admin/creatives/${creative.creative_id}/status`, { status: newStatus });
      fetchCreatives();
    } catch (e) { console.error(e); }
  };

  const handleEditCreative = async () => {
    if (!editingCreative) return;
    try {
      await axios.put(`/admin/creatives/${editingCreative.creative_id}`, {
        name: editingCreative.name,
        content: editingCreative.content
      });
      fetchCreatives();
      setEditingCreative(null);
      setMessage({ type: "success", text: "Creative updated!" });
    } catch (e) { setMessage({ type: "error", text: "Failed to update creative" }); }
  };

   const handleDownloadCreative = async () => {
    if (!downloadCreative) return;
    try {
      let url = `/admin/creatives/${downloadCreative.creative_id}/download?`;
      if (isPartnerRole) {
        url += `partner_id=${user.partner_id}&`;
      } else if (downloadPartner) {
        url += `partner_id=${downloadPartner}&`;
      }
      if (downloadOfferUrl) url += `offer_url_id=${downloadOfferUrl}&`;
      if (downloadSourceId) url += `source=${encodeURIComponent(downloadSourceId)}&`;
      url += `campaign_id=${id}`;
      
      const response = await axios.get(url, { responseType: 'blob' });
      
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `${downloadCreative.name}.txt`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      
      setOpenDownloadModal(false);
      setDownloadSourceId('');
      setMessage({ type: 'success', text: 'Creative downloaded!' });
    } catch (e) {
      console.error(e);
      setMessage({ type: 'error', text: 'Failed to download' });
    }
  };

   const handleCopyHtml = async () => {
    if (!downloadCreative || downloadCreative.type !== 'html') return;
    
    let trackingLink = `https://${getTrackingDomain()}/track?campaign_id=${id}`;
    if (isPartnerRole) {
      trackingLink += `&partner_id=${user.partner_id}`;
    } else if (downloadPartner) {
      trackingLink += `&partner_id=${downloadPartner}`;
    }
    if (downloadOfferUrl) trackingLink += `&offer_url_id=${downloadOfferUrl}`;
    if (downloadCreative?.creative_id) trackingLink += `&creative_id=${downloadCreative.creative_id}`;
    if (downloadSourceId) trackingLink += `&source=${encodeURIComponent(downloadSourceId)}`;
    
    let content = downloadCreative.content;
    
    // Replace {tracking_link} placeholder
    content = content.replace(/\{tracking_link\}/g, trackingLink);
    
    // Also replace any existing tracking links that match the pattern
    // This handles cases where HTML already has hardcoded tracking URLs
    const trackingUrlPattern = /https?:\/\/(www\.)?trcktoo\.com\/track\?[^"'\s<]*/g;
    content = content.replace(trackingUrlPattern, trackingLink);
    
    navigator.clipboard.writeText(content);
    setOpenDownloadModal(false);
    setDownloadSourceId('');
    setMessage({ type: 'success', text: 'HTML copied with tracking link!' });
  };

  const getPartnerPayoutDisplay = () => {
    if (!partnerPayout) return '-';
    
    // If custom payout is set
    if (partnerPayout.custom_payout) {
      if (partnerPayout.custom_payout_type === 'percentage') {
        // Calculate euro value from percentage
        const euroValue = (parseFloat(partnerPayout.default_payout || 0) * parseFloat(partnerPayout.custom_payout)) / 100;
        return `€${euroValue.toFixed(2)}`;
      }
      return `€${parseFloat(partnerPayout.custom_payout).toFixed(2)}`;
    }
    
    // Use default payout
    if (partnerPayout.default_payout_type === 'percentage') {
      // Calculate euro value from percentage
      const euroValue = (parseFloat(partnerPayout.default_payout || 0) * parseFloat(partnerPayout.payout_percentage || 0)) / 100;
      return `€${euroValue.toFixed(2)}`;
    }
    
    return `€${parseFloat(partnerPayout.payout_percentage || 0).toFixed(2)}`;
  };

  if (loading) return <Box display="flex" justifyContent="center" p={4}><CircularProgress /></Box>;
  if (!campaign) return <Box p={3}><Typography>Campaign not found</Typography><Button onClick={() => navigate('/campaigns')}>Back</Button></Box>;

  // Partner view tabs
  const partnerTabs = ['Campaign Info', 'Creatives'];
  // Admin/Manager view tabs
const adminTabs = ['General', 'Tracking', 'Offer URLs', 'Events', 'Partners', 'Settings', 'Creatives', 'Email Presets'];

  return (
    <Box>
      {message.text && <Alert severity={message.type} onClose={() => setMessage({ type: '', text: '' })} sx={{ mb: 2 }}>{message.text}</Alert>}
      
      {/* Header */}
      <Box display="flex" alignItems="center" gap={2} mb={3}>
        <Button startIcon={<ArrowBack />} onClick={() => navigate('/campaigns')}>Back</Button>
        <Typography variant="h5" fontWeight={700} flexGrow={1}>{campaign.name}</Typography>
        <Chip label={campaign.status === 'active' ? 'Active' : 'Inactive'} color={campaign.status === 'active' ? 'success' : 'error'} sx={{ color: 'white' }} />
        <Button variant="contained" startIcon={<LinkIcon />} onClick={() => setOpenTrackingLinkModal(true)}>
          Generate Tracking Link
        </Button>
      </Box>

      {/* Tabs */}
      <Paper sx={{ mb: 3 }}>
        <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} variant="scrollable" scrollButtons="auto">
          {isPartnerRole ? (
            partnerTabs.map((label, i) => <Tab key={i} label={label} />)
          ) : (
            adminTabs.map((label, i) => <Tab key={i} label={label} />)
          )}
        </Tabs>
      </Paper>

      {/* Tab Content */}
      <Card>
        <CardContent>
          {/* PARTNER VIEW - Campaign Info */}
          {isPartnerRole && tabValue === 0 && (
            <Box>
              <Typography variant="h6" mb={3}>Campaign Information</Typography>
              
              <Box display="flex" gap={4} sx={{ mb: 3 }}>
                <Box sx={{ width: '33%' }}>
                  <Typography variant="caption" color="textSecondary" fontWeight={600}>Campaign Name</Typography>
                  <Typography variant="body1" fontWeight={500} sx={{ mt: 0.5 }}>{campaign.name}</Typography>
                </Box>
                <Box sx={{ width: '33%' }}>
                  <Typography variant="caption" color="textSecondary" fontWeight={600}>Campaign ID</Typography>
                  <Typography variant="body1" fontWeight={500} sx={{ mt: 0.5 }}>{campaign.campaign_id}</Typography>
                </Box>
                <Box sx={{ width: '33%' }}>
                  <Typography variant="caption" color="textSecondary" fontWeight={600}>Partner Payout</Typography>
                  <Typography variant="body1" fontWeight={500} color="success.main" sx={{ mt: 0.5 }}>
                    {getPartnerPayoutDisplay()}
                  </Typography>
                </Box>
              </Box>

              <Box>
                <Typography variant="caption" color="textSecondary" fontWeight={600}>Description</Typography>
                <Paper variant="outlined" sx={{ p: 2, mt: 0.5, minHeight: 120, bgcolor: '#fafafa' }}>
                  <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>{campaign.description || 'No description'}</Typography>
                </Paper>
              </Box>
            </Box>
          )}

          {/* PARTNER VIEW - Creatives */}
          {isPartnerRole && tabValue === 1 && (
            <Box>
              <Typography variant="h6" mb={3}>Creatives</Typography>
              <TableContainer component={Paper} variant="outlined">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Preview</TableCell>
                      <TableCell align="right">Download</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {creatives.length === 0 ? (
                      <TableRow><TableCell colSpan={4} align="center">No creatives available</TableCell></TableRow>
                    ) : creatives.map(c => (
                      <TableRow key={c.creative_id}>
                        <TableCell><Typography fontWeight={500}>{c.name}</Typography></TableCell>
                        <TableCell><Chip label={c.type.toUpperCase()} size="small" color={c.type === 'html' ? 'primary' : 'secondary'} /></TableCell>
                        <TableCell>
                          <Button size="small" variant="text" onClick={() => { setPreviewCreative(c); setOpenPreviewModal(true); }}>
                            {c.type === 'image' ? 'View Image' : 'Preview'}
                          </Button>
                        </TableCell>
                        <TableCell align="right">
                          {c.type === 'html' ? (
                            <Button size="small" startIcon={<Download />} onClick={() => { setDownloadCreative(c); setOpenDownloadModal(true); }}>
                              Download
                            </Button>
                          ) : (
                            <Button size="small" startIcon={<Download />} component="a" href={c.file_path} download={c.name}>
                              Download
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}


      {/* ADMIN/MANAGER VIEW - General */}
          {!isPartnerRole && tabValue === 0 && (
            <Box>
              {/* Header with Edit button */}
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h6">Campaign Information</Typography>
                {!editMode ? (
                  <Button startIcon={<Edit />} variant="outlined" onClick={() => setEditMode(true)}>Edit</Button>
                ) : (
                  <Box display="flex" gap={1}>
                    <Button startIcon={<Save />} variant="contained" onClick={handleSave}>Save</Button>
                    <Button startIcon={<Cancel />} variant="outlined" onClick={() => { setEditMode(false); fetchCampaign(); }}>Cancel</Button>
                  </Box>
                )}
              </Box>

              {/* Section: Basic Info */}
              <Paper variant="outlined" sx={{ p: 2.5, mb: 3 }}>
                <Typography variant="subtitle2" color="primary" fontWeight={600} mb={2}>📋 Basic Information</Typography>
                <Box display="flex" gap={4} flexWrap="wrap">
                  <Box sx={{ flex: '1 1 30%', minWidth: 200 }}>
                    <Typography variant="caption" color="textSecondary" fontWeight={600}>Campaign Name</Typography>
                    {editMode ? (
                      <TextField fullWidth size="small" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} sx={{ mt: 0.5 }} />
                    ) : (
                      <Typography variant="body1" fontWeight={500} sx={{ mt: 0.5 }}>{campaign.name}</Typography>
                    )}
                  </Box>
                  <Box sx={{ flex: '1 1 15%', minWidth: 100 }}>
                    <Typography variant="caption" color="textSecondary" fontWeight={600}>Campaign ID</Typography>
                    <Typography variant="body1" fontWeight={500} sx={{ mt: 0.5 }}>{campaign.campaign_id}</Typography>
                  </Box>
                  <Box sx={{ flex: '1 1 25%', minWidth: 180 }}>
                    <Typography variant="caption" color="textSecondary" fontWeight={600}>Advertiser</Typography>
                    {editMode ? (
                      <FormControl fullWidth size="small" sx={{ mt: 0.5 }}>
                        <Select value={formData.advertiser_id} onChange={e => setFormData({...formData, advertiser_id: e.target.value})} displayEmpty>
                          <MenuItem value="">Select Advertiser</MenuItem>
                          {advertisers.map((adv) => (
                            <MenuItem key={adv.advertiser_id} value={adv.advertiser_id}>{adv.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : (
                      <Typography variant="body1" fontWeight={500} sx={{ mt: 0.5 }}>{campaign.advertiser_name || '-'}</Typography>
                    )}
                  </Box>
                  <Box sx={{ flex: '1 1 20%', minWidth: 150 }}>
                    <Typography variant="caption" color="textSecondary" fontWeight={600}>Category</Typography>
                    {editMode ? (
                      <FormControl fullWidth size="small" sx={{ mt: 0.5 }}>
                        <Select value={formData.category_id} onChange={e => setFormData({...formData, category_id: e.target.value})} displayEmpty>
                          <MenuItem value="">Select Category</MenuItem>
                          {categories.map((cat) => (
                            <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : (
                      <Typography variant="body1" fontWeight={500} sx={{ mt: 0.5 }}>{categories.find(c => c.id === parseInt(formData.category_id))?.name || '-'}</Typography>
                    )}
                  </Box>
                </Box>
              </Paper>

              {/* Section: Payout */}
              <Paper variant="outlined" sx={{ p: 2.5, mb: 3 }}>
                <Typography variant="subtitle2" color="primary" fontWeight={600} mb={2}>💰 Revenue & Payout</Typography>
                <Box display="flex" gap={4} flexWrap="wrap">
                  <Box sx={{ flex: '1 1 30%', minWidth: 150 }}>
                    <Typography variant="caption" color="textSecondary" fontWeight={600}>Revenue (€)</Typography>
                    {editMode ? (
                      <TextField fullWidth size="small" type="number" value={formData.revenue} onChange={e => setFormData({...formData, revenue: e.target.value})} sx={{ mt: 0.5 }} />
                    ) : (
                      <Typography variant="body1" fontWeight={600} color="success.main" sx={{ mt: 0.5 }}>€{parseFloat(campaign.revenue || 0).toFixed(2)}</Typography>
                    )}
                  </Box>
                  <Box sx={{ flex: '1 1 30%', minWidth: 150 }}>
                    <Typography variant="caption" color="textSecondary" fontWeight={600}>Partner Payout Type</Typography>
                    {editMode ? (
                      <FormControl fullWidth size="small" sx={{ mt: 0.5 }}>
                        <Select value={formData.payout_type} onChange={e => setFormData({...formData, payout_type: e.target.value})}>
                          <MenuItem value="fixed">Fixed Amount (CPA)</MenuItem>
                          <MenuItem value="percentage">Percentage (PRV)</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      <Typography variant="body1" fontWeight={500} sx={{ mt: 0.5 }}>{formData.payout_type === 'fixed' ? 'Fixed (CPA)' : 'Percentage (PRV)'}</Typography>
                    )}
                  </Box>
                  <Box sx={{ flex: '1 1 30%', minWidth: 150 }}>
                    <Typography variant="caption" color="textSecondary" fontWeight={600}>Partner Payout</Typography>
                    {editMode ? (
                      <TextField fullWidth size="small" type="number" value={formData.payout_percentage} onChange={e => setFormData({...formData, payout_percentage: e.target.value})} sx={{ mt: 0.5 }}
                        helperText={formData.payout_type === 'percentage' && formData.payout && formData.payout_percentage ? `= €${(parseFloat(formData.payout) * parseFloat(formData.payout_percentage) / 100).toFixed(2)}` : ''} />
                    ) : (
                      <Typography variant="body1" fontWeight={600} color="primary" sx={{ mt: 0.5 }}>
                        {formData.payout_type === 'fixed' 
                          ? `€${parseFloat(formData.payout_percentage || 0).toFixed(2)}` 
                          : `${formData.payout_percentage || 0}% (€${(parseFloat(campaign.payout || 0) * parseFloat(formData.payout_percentage || 0) / 100).toFixed(2)})`}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Paper>

              {/* Section: Destination */}
              <Paper variant="outlined" sx={{ p: 2.5, mb: 3 }}>
                <Typography variant="subtitle2" color="primary" fontWeight={600} mb={2}>🔗 Destination</Typography>
                <Typography variant="caption" color="textSecondary" fontWeight={600}>Base Destination URL</Typography>
                {editMode ? (
                  <TextField fullWidth size="small" value={formData.base_destination_url} onChange={e => setFormData({...formData, base_destination_url: e.target.value})} sx={{ mt: 0.5 }} placeholder="https://example.com/landing" />
                ) : (
                  <Typography variant="body1" sx={{ mt: 0.5, wordBreak: 'break-all' }}>{campaign.base_destination_url || '-'}</Typography>
                )}
              </Paper>

              {/* Section: Description */}
              <Paper variant="outlined" sx={{ p: 2.5, mb: 3 }}>
                <Typography variant="subtitle2" color="primary" fontWeight={600} mb={2}>📝 Description</Typography>
                {editMode ? (
                  <TextField fullWidth multiline rows={4} value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} placeholder="Campaign description..." />
                ) : (
                  <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', color: campaign.description ? 'inherit' : 'text.secondary' }}>
                    {campaign.description || 'No description'}
                  </Typography>
                )}
              </Paper>

              {/* Section: Internal Notes */}
              <Paper variant="outlined" sx={{ p: 2.5, bgcolor: '#fffde7', borderColor: '#ffe082' }}>
                <Typography variant="subtitle2" color="warning.dark" fontWeight={600} mb={2}>🔒 Internal Notes (Admin/Manager only)</Typography>
                {editMode ? (
                  <TextField fullWidth multiline rows={3} value={formData.internal_notes} onChange={e => setFormData({...formData, internal_notes: e.target.value})} placeholder="Notes visible only to admin and managers..." />
                ) : (
                  <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', color: campaign.internal_notes ? 'inherit' : 'text.secondary' }}>
                    {campaign.internal_notes || 'No internal notes'}
                  </Typography>
                )}
              </Paper>
            </Box>
          )}

   {/* ADMIN/MANAGER VIEW - Tracking */}
          {!isPartnerRole && tabValue === 1 && (
            <Box>
              <Typography variant="h6" mb={3}>Tracking Configuration</Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl fullWidth sx={{ minWidth: 300 }}>
                    <InputLabel>Tracking Domain</InputLabel>
                    <Select 
                      value={formData.tracking_domain_id} 
                      label="Tracking Domain" 
                      onChange={e => setFormData({...formData, tracking_domain_id: e.target.value})}
                    >
                      <MenuItem value="">
                        <em>Use Primary Domain</em>
                      </MenuItem>
                      {trackingDomains.filter(d => d.is_active).map(d => (
                        <MenuItem key={d.id} value={d.id}>
                          {d.domain} {d.is_primary && <Chip size="small" label="Primary" sx={{ ml: 1 }} />}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth sx={{ minWidth: 300 }}>
                    <InputLabel>Tracking Type</InputLabel>
                    <Select value={formData.tracking_type} label="Tracking Type" onChange={e => setFormData({...formData, tracking_type: e.target.value})}>
                      <MenuItem value="postback">Postback URL</MenuItem>
                      <MenuItem value="pixel">Pixel Code</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {formData.tracking_type === 'postback' && (
                  <>
                    <Grid item xs={12}>
                      <Paper sx={{ p: 2, bgcolor: '#e8f5e9', border: '1px solid #81c784' }}>
                        <Typography variant="subtitle2" fontWeight={600} color="success.main" mb={1}>
                          🌐 Global Postback URL (for Advertiser)
                        </Typography>
                        <Typography variant="body2" color="textSecondary" mb={2}>
                          Share this universal postback URL with your advertiser. It works for all campaigns - just pass the click_id.
                        </Typography>
                        <Box sx={{ bgcolor: '#fff', p: 2, borderRadius: 1, fontFamily: 'monospace', fontSize: '0.9rem', wordBreak: 'break-all', border: '1px solid #c8e6c9' }}>
                          {`https://${(trackingDomains.find(d => formData.tracking_domain_id ? d.id === Number(formData.tracking_domain_id) : d.is_primary)?.domain) || 'trcktoo.com'}/postback?click_id={click_id}`}
                        </Box>
                        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                          <Button 
                            variant="contained" 
                            color="success"
                            size="small" 
                            startIcon={<ContentCopy />} 
                            onClick={() => { 
                              const domain = (trackingDomains.find(d => formData.tracking_domain_id ? d.id === Number(formData.tracking_domain_id) : d.is_primary)?.domain) || 'trcktoo.com';
                              navigator.clipboard.writeText(`https://${domain}/postback?click_id={click_id}`); 
                              setMessage({ type: 'success', text: 'Global Postback URL copied!' }); 
                            }}
                          >
                            Copy Global Postback
                          </Button>
                        </Box>
                        <Box sx={{ mt: 2, p: 1.5, bgcolor: '#fff', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                          <Typography variant="caption" fontWeight={600} display="block" mb={1}>Available Parameters:</Typography>
                          <Typography variant="caption" component="div"><code>click_id</code> - Required. The click ID from the tracking link</Typography>
                          <Typography variant="caption" component="div"><code>event_code</code> - Optional. For multi-event tracking</Typography>
                          <Typography variant="caption" component="div"><code>payout</code> - Optional. Override payout amount</Typography>
                          <Typography variant="caption" component="div"><code>revenue</code> - Optional. Override revenue amount</Typography>
                        </Box>
                      </Paper>
                    </Grid>

                    <Grid item xs={12}>
                      <Paper sx={{ p: 2, bgcolor: '#f5f5f5', mb: 2 }}>
                        <Typography variant="subtitle2" fontWeight={600} color="primary" mb={1}>
                          Campaign-Specific Postback (Alternative)
                        </Typography>
                        <Typography variant="body2" color="textSecondary" mb={2}>
                          If the advertiser needs a campaign-specific URL, they can use this one instead.
                        </Typography>
                        <Box sx={{ bgcolor: '#e3f2fd', p: 2, borderRadius: 1, fontFamily: 'monospace', fontSize: '0.85rem', wordBreak: 'break-all', border: '1px solid #90caf9' }}>
                          {`https://${(trackingDomains.find(d => formData.tracking_domain_id ? d.id === Number(formData.tracking_domain_id) : d.is_primary)?.domain) || 'trcktoo.com'}/postback?campaign_id=${id}&click_id={click_id}`}
                        </Box>
                        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                          <Button 
                            variant="outlined" 
                            size="small" 
                            startIcon={<ContentCopy />} 
                            onClick={() => { 
                              const domain = (trackingDomains.find(d => formData.tracking_domain_id ? d.id === Number(formData.tracking_domain_id) : d.is_primary)?.domain) || 'trcktoo.com';
                              navigator.clipboard.writeText(`https://${domain}/postback?campaign_id=${id}&click_id={click_id}`); 
                              setMessage({ type: 'success', text: 'Campaign Postback URL copied!' }); 
                            }}
                          >
                            Copy Campaign Postback
                          </Button>
                        </Box>
                      </Paper>
                      <TextField 
                        fullWidth 
                        label="Your Postback URL (Optional - We call this when conversion received)" 
                        value={formData.postback_url} 
                        onChange={e => setFormData({...formData, postback_url: e.target.value})} 
                        placeholder="https://your-system.com/postback?lead_id={lead_id}&status={status}" 
                        helperText="We will call this URL when we receive a conversion. Macros: {lead_id}, {click_id}, {status}, {payout}, {partner_id}"
                      />
                    </Grid>
                  </>
                )}

                {formData.tracking_type === 'pixel' && (
                  <Grid item xs={12}>
                    <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                      <Typography variant="subtitle2" fontWeight={600} color="success.main" mb={1}>🎯 Pixel per Thank You Page</Typography>
                      <Typography variant="body2" color="textSecondary" mb={2}>
                        Inserisci questo codice nella Thank You Page. Funziona automaticamente tramite IP/User Agent (no click_id richiesto).
                      </Typography>
                      <Box sx={{ bgcolor: '#263238', color: '#aed581', p: 2, borderRadius: 1, fontFamily: 'monospace', fontSize: '0.85rem', mb: 2 }}>
{`<img src="https://${(trackingDomains.find(d => formData.tracking_domain_id ? d.id === Number(formData.tracking_domain_id) : d.is_primary)?.domain) || 'trcktoo.com'}/pixel?campaign_id=${id}" width="1" height="1" style="display:none" />`}
                      </Box>
                      <Button variant="contained" size="small" startIcon={<ContentCopy />} onClick={() => { 
                        const domain = (trackingDomains.find(d => formData.tracking_domain_id ? d.id === Number(formData.tracking_domain_id) : d.is_primary)?.domain) || 'trcktoo.com';
                        navigator.clipboard.writeText(`<img src="https://${domain}/pixel?campaign_id=${id}" width="1" height="1" style="display:none" />`); 
                        setMessage({ type: 'success', text: 'Pixel copiato!' }); 
                      }}>Copia Pixel</Button>
                    </Paper>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Paper sx={{ p: 2, bgcolor: '#fff3e0', border: '1px solid #ffb74d' }}>
                    <Typography variant="subtitle2" fontWeight={600} color="warning.main" mb={1}>
                      🔗 Partner Tracking Link Preview
                    </Typography>
                    <Typography variant="body2" color="textSecondary" mb={2}>
                      This is how the tracking link will look for partners using this campaign.
                    </Typography>
                    <Box sx={{ bgcolor: '#fff', p: 2, borderRadius: 1, fontFamily: 'monospace', fontSize: '0.85rem', wordBreak: 'break-all', border: '1px solid #ffe0b2' }}>
                      {`https://${(trackingDomains.find(d => formData.tracking_domain_id ? d.id === Number(formData.tracking_domain_id) : d.is_primary)?.domain) || 'trcktoo.com'}/track?campaign_id=${id}&partner_id={PARTNER_ID}`}
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
              <Box mt={3}><Button variant="contained" onClick={handleSave}>Save Tracking</Button></Box>
            </Box>
          )}



          {/* ADMIN/MANAGER VIEW - Offer URLs */}
          {!isPartnerRole && tabValue === 2 && (
            <Box>
              <Box display="flex" justifyContent="space-between" mb={3}>
                <Typography variant="h6">Offer URLs</Typography>
                <Button variant="contained" startIcon={<Add />} onClick={() => openOfferUrlEdit()}>Add URL</Button>
              </Box>
              <TableContainer component={Paper} variant="outlined">
                <Table>
                  <TableHead><TableRow><TableCell>ID</TableCell><TableCell>Name</TableCell><TableCell>URL</TableCell><TableCell>Default</TableCell><TableCell align="right">Actions</TableCell></TableRow></TableHead>
                  <TableBody>
                    {offerUrls.length === 0 ? (
                      <TableRow><TableCell colSpan={5} align="center">No offer URLs. Click "Add URL" to create one.</TableCell></TableRow>
                    ) : offerUrls.map(url => (
                      <TableRow key={url.offer_url_id}>
                        <TableCell>{url.offer_url_id}</TableCell><TableCell>{url.name}</TableCell>
                        <TableCell sx={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>{url.url_template}</TableCell>
                        <TableCell>{url.is_default && <Chip label="Default" size="small" color="primary" />}</TableCell>
                        <TableCell align="right">
                          <IconButton size="small" onClick={() => openOfferUrlEdit(url)}><Edit fontSize="small" /></IconButton>
                          <IconButton size="small" color="error" onClick={() => handleDeleteOfferUrl(url.offer_url_id)}><Delete fontSize="small" /></IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          {/* ADMIN/MANAGER VIEW - Events */}
          {!isPartnerRole && tabValue === 3 && (
            <Box>
              <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={3}>
                <Box>
                  <Typography variant="h6">Conversion Events</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Define different payout levels for various conversion types (lead, sale, upsell, etc.)
                  </Typography>
                </Box>
                <Button variant="contained" startIcon={<Add />} onClick={() => openEventEdit()}>Add Event</Button>
              </Box>

              {/* How Events Work */}
              <Paper sx={{ p: 2, mb: 3, bgcolor: '#e3f2fd', border: '1px solid #90caf9' }}>
                <Typography variant="subtitle2" fontWeight={600} color="primary" mb={1}>
                  📘 How Events Work
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                  Events allow you to track different conversion types with different payouts. The advertiser adds <code>&event=EVENT_CODE</code> to the postback URL.
                </Typography>
                <Box sx={{ bgcolor: '#fff', p: 2, borderRadius: 1, fontFamily: 'monospace', fontSize: '0.85rem', mb: 2 }}>
                  https://{getTrackingDomain()}/postback?click_id={'{click_id}'}&event={'{event_code}'}
                </Box>
                <Typography variant="caption" color="text.secondary">
                  Example: If you create an event with code "sale", the advertiser calls: <code>...&event=sale</code>
                </Typography>
              </Paper>

              <TableContainer component={Paper} variant="outlined">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Event Name</TableCell>
                      <TableCell>Code</TableCell>
                      <TableCell align="right">Revenue</TableCell>
                      <TableCell align="right">Partner Payout</TableCell>
                      <TableCell>Postback URL</TableCell>
                      <TableCell>Default</TableCell>
                      <TableCell align="right">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {conversionEvents.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          <Box py={3}>
                            <Typography color="text.secondary" mb={1}>No events configured</Typography>
                            <Typography variant="caption" color="text.secondary">
                              Without events, the campaign uses the default payout (€{parseFloat(campaign.payout || 0).toFixed(2)})
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : conversionEvents.map(ev => (
                      <TableRow key={ev.event_id}>
                        <TableCell><Typography fontWeight={600}>{ev.event_name}</Typography></TableCell>
                        <TableCell>
                          <Chip label={ev.event_code} size="small" variant="outlined" sx={{ fontFamily: 'monospace' }} />
                        </TableCell>
                        <TableCell align="right">€{parseFloat(ev.revenue_amount || 0).toFixed(2)}</TableCell>
                        <TableCell align="right" sx={{ color: 'success.main', fontWeight: 600 }}>{calculatePayout(ev)}</TableCell>
                        <TableCell>
                          {ev.postback_url ? (
                            <Chip label="Configured" size="small" color="success" sx={{ color: 'white' }} />
                          ) : (
                            <Chip label="None" size="small" color="default" />
                          )}
                        </TableCell>
                        <TableCell>{ev.is_default && <Chip label="Default" size="small" color="primary" />}</TableCell>
                        <TableCell align="right">
                          <IconButton size="small" onClick={() => openEventEdit(ev)} title="Edit"><Edit fontSize="small" /></IconButton>
                          <IconButton size="small" color="error" onClick={() => handleDeleteEvent(ev.event_id)} title="Delete"><Delete fontSize="small" /></IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Event Postback Examples */}
              {conversionEvents.length > 0 && (
                <Paper sx={{ p: 2, mt: 3, bgcolor: '#f5f5f5' }}>
                  <Typography variant="subtitle2" fontWeight={600} mb={2}>
                    📋 Postback Examples for Advertiser
                  </Typography>
                  {conversionEvents.map(ev => (
                    <Box key={ev.event_id} sx={{ mb: 1, p: 1.5, bgcolor: '#fff', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                      <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                        <Typography variant="body2" fontWeight={600}>{ev.event_name}</Typography>
                        <Typography variant="caption" color="success.main" fontWeight={600}>
                          Revenue: €{parseFloat(ev.revenue_amount || 0).toFixed(2)} → Payout: {calculatePayout(ev)}
                        </Typography>
                      </Box>
                      <Box sx={{ fontFamily: 'monospace', fontSize: '0.8rem', color: '#1565c0', wordBreak: 'break-all' }}>
                        https://{getTrackingDomain()}/postback?click_id={'{click_id}'}&event={ev.event_code}
                      </Box>
                      <Button 
                        size="small" 
                        sx={{ mt: 1 }}
                        onClick={() => {
                          navigator.clipboard.writeText(`https://${getTrackingDomain()}/postback?click_id={click_id}&event=${ev.event_code}`);
                          setMessage({ type: 'success', text: `Postback for "${ev.event_name}" copied!` });
                        }}
                      >
                        Copy Postback
                      </Button>
                    </Box>
                  ))}
                </Paper>
              )}
            </Box>
          )}

         {/* ADMIN/MANAGER VIEW - Partners */}
          {!isPartnerRole && tabValue === 4 && (
            <>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Box>
                  <Typography variant="h6">Partner Management</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Assign partners and set custom payouts. Default payout: €{parseFloat(formData.payout_percentage || 0).toFixed(2)} ({formData.payout_type === 'fixed' ? 'CPA' : 'PRV'})
                  </Typography>
                </Box>
              </Box>

              <Box display="flex" gap={3} flexDirection={{ xs: 'column', md: 'row' }}>
                {/* Assigned Partners */}
                <Paper variant="outlined" sx={{ p: 2, flex: 1, minWidth: 0 }}>
                  <Typography variant="subtitle1" fontWeight={600} color="success.main" mb={2}>
                    ✓ Assigned Partners ({selectedPartners.length})
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Search partners..."
                    value={partnerSearchAssign}
                    onChange={(e) => setPartnerSearchAssign(e.target.value)}
                    sx={{ mb: 2 }}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><Search sx={{ fontSize: 20, color: 'text.secondary' }} /></InputAdornment>
                    }}
                  />
                  <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                    {partners
                      .filter(p => p.status === 'active' && !blacklistedPartners.includes(p.partner_id))
                      .filter(p => !partnerSearchAssign || p.name.toLowerCase().includes(partnerSearchAssign.toLowerCase()) || p.email?.toLowerCase().includes(partnerSearchAssign.toLowerCase()))
                      .map(p => (
                        <Paper 
                          key={p.partner_id} 
                          variant="outlined" 
                          sx={{ 
                            p: 1.5, 
                            mb: 1, 
                            cursor: 'pointer',
                            bgcolor: selectedPartners.includes(p.partner_id) ? '#e8f5e9' : '#fff',
                            border: selectedPartners.includes(p.partner_id) ? '1px solid #81c784' : '1px solid #e0e0e0',
                            '&:hover': { bgcolor: selectedPartners.includes(p.partner_id) ? '#c8e6c9' : '#f5f5f5' }
                          }}
                        >
                          <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Box display="flex" alignItems="center" onClick={() => handleTogglePartner(p.partner_id)} sx={{ flex: 1, cursor: 'pointer' }}>
                              <Checkbox 
                                checked={selectedPartners.includes(p.partner_id)} 
                                size="small"
                                color="success"
                              />
                              <Box ml={1}>
                                <Typography variant="body2" fontWeight={500}>{p.name}</Typography>
                                <Typography variant="caption" color="text.secondary">{p.email}</Typography>
                              </Box>
                            </Box>
                            {selectedPartners.includes(p.partner_id) && (
                              <Box display="flex" alignItems="center" gap={1}>
                                <Button
                                  size="small"
                                  variant={partnerPayouts[p.partner_id] ? "contained" : "outlined"}
                                  color={partnerPayouts[p.partner_id] ? "primary" : "inherit"}
                                  onClick={(e) => { e.stopPropagation(); handleOpenPayoutModal(p); }}
                                  sx={{ minWidth: 70, fontSize: '0.75rem' }}
                                >
                                  {partnerPayouts[p.partner_id] ? `€${partnerPayouts[p.partner_id].custom_payout}` : 'Default'}
                                </Button>
                                <IconButton 
                                  size="small" 
                                  color="error" 
                                  onClick={(e) => { e.stopPropagation(); handleToggleBlacklist(p.partner_id); }}
                                  title="Add to blacklist"
                                >
                                  <Block fontSize="small" />
                                </IconButton>
                              </Box>
                            )}
                          </Box>
                        </Paper>
                      ))}
                    {partners.filter(p => p.status === 'active' && !blacklistedPartners.includes(p.partner_id)).length === 0 && (
                      <Typography color="text.secondary" textAlign="center" py={3}>No partners available</Typography>
                    )}
                  </Box>
                </Paper>

                {/* Blacklisted Partners */}
                <Paper variant="outlined" sx={{ p: 2, flex: 1, minWidth: 0, bgcolor: '#fffafa' }}>
                  <Typography variant="subtitle1" fontWeight={600} color="error.main" mb={2}>
                    ⛔ Blacklisted Partners ({blacklistedPartners.length})
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Search to blacklist..."
                    value={partnerSearchBlacklist}
                    onChange={(e) => setPartnerSearchBlacklist(e.target.value)}
                    sx={{ mb: 2 }}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><Search sx={{ fontSize: 20, color: 'text.secondary' }} /></InputAdornment>
                    }}
                  />
                  <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                    {partners
                      .filter(p => blacklistedPartners.includes(p.partner_id))
                      .filter(p => !partnerSearchBlacklist || p.name.toLowerCase().includes(partnerSearchBlacklist.toLowerCase()))
                      .map(p => (
                        <Paper 
                          key={p.partner_id} 
                          variant="outlined" 
                          sx={{ p: 1.5, mb: 1, bgcolor: '#ffebee', border: '1px solid #ef9a9a' }}
                        >
                          <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Box>
                              <Typography variant="body2" fontWeight={500}>{p.name}</Typography>
                              <Typography variant="caption" color="text.secondary">{p.email}</Typography>
                            </Box>
                            <Button 
                              size="small" 
                              color="success"
                              variant="outlined"
                              onClick={() => handleToggleBlacklist(p.partner_id)}
                            >
                              Remove
                            </Button>
                          </Box>
                        </Paper>
                      ))}
                    
                    {partnerSearchBlacklist && partners
                      .filter(p => p.status === 'active' && !blacklistedPartners.includes(p.partner_id))
                      .filter(p => p.name.toLowerCase().includes(partnerSearchBlacklist.toLowerCase()))
                      .map(p => (
                        <Paper 
                          key={p.partner_id} 
                          variant="outlined" 
                          sx={{ p: 1.5, mb: 1, bgcolor: '#fff', border: '1px dashed #e0e0e0' }}
                        >
                          <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Box>
                              <Typography variant="body2" fontWeight={500}>{p.name}</Typography>
                              <Typography variant="caption" color="text.secondary">{p.email}</Typography>
                            </Box>
                            <Button 
                              size="small" 
                              color="error"
                              variant="outlined"
                              onClick={() => handleToggleBlacklist(p.partner_id)}
                            >
                              Blacklist
                            </Button>
                          </Box>
                        </Paper>
                      ))}

                    {blacklistedPartners.length === 0 && !partnerSearchBlacklist && (
                      <Box textAlign="center" py={3}>
                        <Typography color="text.secondary">No blacklisted partners.</Typography>
                        <Typography variant="caption" color="text.secondary">Search above to add partners to blacklist</Typography>
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Box>
            </>
          )}

{/* ADMIN/MANAGER VIEW - Settings */}
          {!isPartnerRole && tabValue === 5 && (
            <Box>
              <Typography variant="h6" mb={3}>Campaign Settings</Typography>
              <Grid container spacing={3}>
                 <Grid item xs={12}>
                  <Paper variant="outlined" sx={{ p: 2, bgcolor: formData.cap_reached ? '#fef2f2' : '#f0fdf4', border: formData.cap_reached ? '1px solid #ef4444' : '1px solid #22c55e' }}>
                    <FormControlLabel
                      control={
                        <Switch 
                          checked={formData.cap_reached || false} 
                          onChange={e => setFormData({...formData, cap_reached: e.target.checked})}
                          color="error"
                        />
                      }
                      label={
                        <Box>
                          <Typography fontWeight={600} color={formData.cap_reached ? 'error.main' : 'text.primary'}>Cap Reached</Typography>
                          <Typography variant="body2" color="textSecondary">
                            When enabled, this campaign cannot be scheduled on DEM calendar. Resets automatically on the 1st of each month.
                          </Typography>
                        </Box>
                      }
                    />
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Paper variant="outlined" sx={{ p: 2, bgcolor: '#fffbeb', border: '1px solid #fbbf24' }}>
                    <FormControlLabel
                      control={
                        <Switch 
                          checked={formData.requires_approval} 
                          onChange={e => setFormData({...formData, requires_approval: e.target.checked})}
                          color="warning"
                        />
                      }
                      label={
                        <Box>
                          <Typography fontWeight={600}>Require Manual Approval</Typography>
                          <Typography variant="body2" color="textSecondary">
                            When enabled, all conversions will be set to "pending" and require manual approval before being visible to partners.
                          </Typography>
                        </Box>
                      }
                    />
                  </Paper>
                </Grid>
              </Grid>
              <Box mt={3}><Button variant="contained" onClick={handleSave}>Save Settings</Button></Box>
            </Box>
          )}

          {/* ADMIN/MANAGER VIEW - Creatives */}
          {!isPartnerRole && tabValue === 6 && (
            <Box>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h6">Creatives</Typography>
                <Box display="flex" gap={2}>
                  <FormControl size="small" sx={{ minWidth: 120 }}>
                    <Select value={creativeFilter} onChange={(e) => setCreativeFilter(e.target.value)}>
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                      <MenuItem value="all">All</MenuItem>
                    </Select>
                  </FormControl>
                  <Button variant="outlined" component="label" startIcon={<Upload />}>
                    Upload Image
                    <input type="file" hidden accept="image/*" onChange={handleImageUpload} />
                  </Button>
                  <Button variant="contained" startIcon={<Add />} onClick={() => { setCreativeType('html'); setOpenCreativeModal(true); }}>
                    Add HTML
                  </Button>
                </Box>
              </Box>

              <TableContainer component={Paper} variant="outlined">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Preview</TableCell>
                      <TableCell align="right">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {creatives.length === 0 ? (
                      <TableRow><TableCell colSpan={6} align="center">No creatives. Add HTML or upload images.</TableCell></TableRow>
                    ) : creatives.map(c => (
                      <TableRow key={c.creative_id}>
                        <TableCell>{c.creative_id}</TableCell>
                        <TableCell><Typography fontWeight={500}>{c.name}</Typography></TableCell>
                        <TableCell><Chip label={c.type.toUpperCase()} size="small" color={c.type === 'html' ? 'primary' : 'secondary'} /></TableCell>
                        <TableCell>
                          <Chip 
                            label={c.status} 
                            size="small" 
                            color={c.status === 'active' ? 'success' : 'default'}
                            onClick={() => handleToggleCreativeStatus(c)}
                            sx={{ cursor: 'pointer' }}
                          />
                        </TableCell>
                        <TableCell>
                          <Button size="small" variant="text" onClick={() => { setPreviewCreative(c); setOpenPreviewModal(true); }}>
                            {c.type === 'image' ? 'View Image' : 'Preview'}
                          </Button>
                        </TableCell>
                     <TableCell align="right">
                          <IconButton size="small" color="primary" onClick={() => setEditingCreative({...c})}><Edit fontSize="small" /></IconButton>
                          {c.type === 'html' ? (
                            <Button size="small" onClick={() => { setDownloadCreative(c); setOpenDownloadModal(true); }}>Download</Button>
                          ) : (
                            <Button size="small" component="a" href={c.file_path} download={c.name}>Download</Button>
                          )}
                          {c.status === 'active' ? (
                            <IconButton size="small" color="error" onClick={() => handleDeleteCreative(c.creative_id)}><Delete fontSize="small" /></IconButton>
                          ) : (
                            <IconButton size="small" color="success" onClick={() => handleToggleCreativeStatus(c)}><Add fontSize="small" /></IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}


          {/* Email Items Tab */}
          {!isPartnerRole && tabValue === 7 && (
            <Card>
              <CardContent>
                <Typography variant="h6" mb={3}>Email Items for Maildome</Typography>
                
                {/* Senders Section */}
                <Box mb={3}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="subtitle1" fontWeight={600}>Senders</Typography>
                    <Button size="small" startIcon={<Add />} onClick={() => setAddingItemType('sender')}>Add</Button>
                  </Box>
                  {addingItemType === 'sender' && (
                    <Box display="flex" gap={1} mb={1}>
                      <TextField size="small" fullWidth placeholder="e.g., Team Promo" value={newItemValue} onChange={(e) => setNewItemValue(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleAddItem('sender')} />
                      <Button variant="contained" size="small" onClick={() => handleAddItem('sender')}>Save</Button>
                      <Button size="small" onClick={() => { setAddingItemType(null); setNewItemValue(''); }}>Cancel</Button>
                    </Box>
                  )}
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    {emailItems.senders.length === 0 ? <Typography color="text.secondary" variant="body2">No senders added</Typography> : 
                      emailItems.senders.map(item => (
                        editingItem?.id === item.id ? (
                          <Box key={item.id} display="flex" gap={1} alignItems="center">
                            <TextField size="small" value={editItemValue} onChange={(e) => setEditItemValue(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleSaveEditItem()} autoFocus />
                            <Button size="small" variant="contained" onClick={handleSaveEditItem}>Save</Button>
                            <Button size="small" onClick={handleCancelEdit}>Cancel</Button>
                          </Box>
                        ) : (
                          <Chip key={item.id} label={item.value} onClick={() => handleEditItem(item)} onDelete={() => handleDeleteItem(item.id)} sx={{ cursor: 'pointer' }} />
                        )
                      ))
                    }
                  </Box>
                </Box>

                {/* Subjects Section */}
                <Box mb={3}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="subtitle1" fontWeight={600}>Subjects</Typography>
                    <Button size="small" startIcon={<Add />} onClick={() => setAddingItemType('subject')}>Add</Button>
                  </Box>
                  {addingItemType === 'subject' && (
                    <Box display="flex" gap={1} mb={1}>
                      <TextField size="small" fullWidth placeholder="e.g., Offerta speciale!" value={newItemValue} onChange={(e) => setNewItemValue(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleAddItem('subject')} />
                      <Button variant="contained" size="small" onClick={() => handleAddItem('subject')}>Save</Button>
                      <Button size="small" onClick={() => { setAddingItemType(null); setNewItemValue(''); }}>Cancel</Button>
                    </Box>
                  )}
                  <Box display="flex" flexWrap="wrap" gap={1}>
                      {emailItems.subjects.length === 0 ? <Typography color="text.secondary" variant="body2">No subjects added</Typography> : 
                      emailItems.subjects.map(item => (
                        editingItem?.id === item.id ? (
                          <Box key={item.id} display="flex" gap={1} alignItems="center">
                            <TextField size="small" value={editItemValue} onChange={(e) => setEditItemValue(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleSaveEditItem()} autoFocus />
                            <Button size="small" variant="contained" onClick={handleSaveEditItem}>Save</Button>
                            <Button size="small" onClick={handleCancelEdit}>Cancel</Button>
                          </Box>
                        ) : (
                          <Chip key={item.id} label={item.value} onClick={() => handleEditItem(item)} onDelete={() => handleDeleteItem(item.id)} sx={{ cursor: 'pointer' }} />
                        )
                      ))
                    }
                  </Box>
                </Box>

                {/* Preheaders Section */}
                <Box mb={3}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="subtitle1" fontWeight={600}>Preheaders</Typography>
                    <Button size="small" startIcon={<Add />} onClick={() => setAddingItemType('preheader')}>Add</Button>
                  </Box>
                  {addingItemType === 'preheader' && (
                    <Box display="flex" gap={1} mb={1}>
                      <TextField size="small" fullWidth placeholder="e.g., Scopri di più" value={newItemValue} onChange={(e) => setNewItemValue(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleAddItem('preheader')} />
                      <Button variant="contained" size="small" onClick={() => handleAddItem('preheader')}>Save</Button>
                      <Button size="small" onClick={() => { setAddingItemType(null); setNewItemValue(''); }}>Cancel</Button>
                    </Box>
                  )}
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    {emailItems.preheaders.length === 0 ? <Typography color="text.secondary" variant="body2">No preheaders added</Typography> : 
                      emailItems.preheaders.map(item => (
                        editingItem?.id === item.id ? (
                          <Box key={item.id} display="flex" gap={1} alignItems="center">
                            <TextField size="small" value={editItemValue} onChange={(e) => setEditItemValue(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleSaveEditItem()} autoFocus />
                            <Button size="small" variant="contained" onClick={handleSaveEditItem}>Save</Button>
                            <Button size="small" onClick={handleCancelEdit}>Cancel</Button>
                          </Box>
                        ) : (
                          <Chip key={item.id} label={item.value} onClick={() => handleEditItem(item)} onDelete={() => handleDeleteItem(item.id)} sx={{ cursor: 'pointer' }} />
                        )
                      ))
                    }
                  </Box>
                </Box>
              </CardContent>
            </Card>
          )}


        </CardContent>
      </Card>

      {/* Tracking Link Modal */}
      <Dialog open={openTrackingLinkModal} onClose={() => setOpenTrackingLinkModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Generate Tracking Link</DialogTitle>
        <DialogContent>
          {!isPartnerRole && (
            <>
              <FormControl fullWidth sx={{ mt: 2, mb: 2 }}>
                <InputLabel>Partner</InputLabel>
                <Select value={selectedPartnerForLink} label="Partner" onChange={e => setSelectedPartnerForLink(e.target.value)}>
                  <MenuItem value="">No Partner</MenuItem>
                  {partners.filter(p => selectedPartners.includes(p.partner_id)).map(p => <MenuItem key={p.partner_id} value={p.partner_id}>{p.name}</MenuItem>)}
                </Select>
              </FormControl>
              {selectedPartners.length === 0 && <Alert severity="warning" sx={{ mb: 2 }}>No partners assigned. Go to Partners tab first.</Alert>}
            </>
          )}
          <FormControl fullWidth sx={{ mb: 2, mt: isPartnerRole ? 2 : 0 }}>
            <InputLabel>Offer URL</InputLabel>
            <Select value={selectedOfferUrlForLink} label="Offer URL" onChange={e => setSelectedOfferUrlForLink(e.target.value)}>
              <MenuItem value="">Default URL</MenuItem>
              {offerUrls.map(u => <MenuItem key={u.offer_url_id} value={u.offer_url_id}>{u.name}</MenuItem>)}
            </Select>
          </FormControl>
          <Paper sx={{ p: 2, bgcolor: '#f5f5f5', wordBreak: 'break-all' }}><Typography variant="body2" fontFamily="monospace">{generateTrackingLink()}</Typography></Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenTrackingLinkModal(false)}>Close</Button>
          <Button variant="contained" startIcon={<ContentCopy />} onClick={copyLink}>Copy Link</Button>
        </DialogActions>
      </Dialog>

      {/* Event Modal - Admin only */}
      {!isPartnerRole && (
        <Dialog open={openEventModal} onClose={() => setOpenEventModal(false)} maxWidth="md" fullWidth>
          <DialogTitle>{editingEvent ? 'Edit Event' : 'Add Conversion Event'}</DialogTitle>
          <DialogContent>
            <Alert severity="info" sx={{ mt: 1, mb: 2 }}>
              Events allow different payouts for different conversion types. The advertiser adds <code>&event=CODE</code> to track this event.
            </Alert>
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item xs={6}>
                <TextField 
                  fullWidth 
                  label="Event Name" 
                  value={eventForm.event_name} 
                  onChange={e => setEventForm({...eventForm, event_name: e.target.value})} 
                  placeholder="e.g., Sale, Lead, Upsell"
                  helperText="Display name for this event"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField 
                  fullWidth 
                  label="Event Code" 
                  value={eventForm.event_code} 
                  InputProps={{ readOnly: !editingEvent }}
                  helperText={!editingEvent ? "Auto-generated" : ""}
                  placeholder="e.g., sale, lead, upsell"
                  helperText="Used in postback URL: &event=CODE"
                />
              </Grid>
              <Grid item xs={12}>
                <Paper sx={{ p: 2, bgcolor: '#e8f5e9', border: '1px solid #81c784' }}>
                  <Typography variant="subtitle2" fontWeight={600} color="success.main" mb={1}>
                    💰 Revenue & Payout
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <TextField 
                        fullWidth 
                        label="Revenue (€)" 
                        type="number" 
                        value={eventForm.revenue_amount} 
                        onChange={e => setEventForm({...eventForm, revenue_amount: e.target.value})} 
                        helperText="What you receive from advertiser"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <FormControl fullWidth>
                        <InputLabel>Payout Type</InputLabel>
                        <Select value={eventForm.payout_type} label="Payout Type" onChange={e => setEventForm({...eventForm, payout_type: e.target.value})}>
                          <MenuItem value="CPA">Fixed Amount (CPA)</MenuItem>
                          <MenuItem value="PRV">Percentage (PRV)</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                      {eventForm.payout_type === 'CPA' ? (
                        <TextField 
                          fullWidth 
                          label="Partner Payout (€)" 
                          type="number" 
                          value={eventForm.payout_amount} 
                          onChange={e => setEventForm({...eventForm, payout_amount: e.target.value})} 
                          helperText="Fixed amount to partner"
                        />
                      ) : (
                        <TextField 
                          fullWidth 
                          label="Partner Payout (%)" 
                          type="number" 
                          value={eventForm.payout_percentage} 
                          onChange={e => setEventForm({...eventForm, payout_percentage: e.target.value})} 
                          helperText={eventForm.revenue_amount && eventForm.payout_percentage ? `= €${(parseFloat(eventForm.revenue_amount) * parseFloat(eventForm.payout_percentage) / 100).toFixed(2)}` : '% of revenue'}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <TextField 
                  fullWidth 
                  label="Event Postback URL (Optional)" 
                  value={eventForm.postback_url} 
                  onChange={e => setEventForm({...eventForm, postback_url: e.target.value})} 
                  placeholder="https://your-crm.com/conversion?lead_id={lead_id}&event={event_code}"
                  helperText="Override campaign postback for this event. Macros: {lead_id}, {click_id}, {payout}, {event_code}"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel 
                  control={<Switch checked={eventForm.is_default} onChange={e => setEventForm({...eventForm, is_default: e.target.checked})} />} 
                  label={
                    <Box>
                      <Typography variant="body2" fontWeight={500}>Default Event</Typography>
                      <Typography variant="caption" color="text.secondary">Used when no event code is specified</Typography>
                    </Box>
                  }
                />
              </Grid>
            </Grid>
            
            {eventForm.event_code && (
              <Paper sx={{ p: 2, mt: 2, bgcolor: '#fff3e0', border: '1px solid #ffb74d' }}>
                <Typography variant="subtitle2" fontWeight={600} color="warning.main" mb={1}>
                  📋 Advertiser Postback Preview
                </Typography>
                <Box sx={{ fontFamily: 'monospace', fontSize: '0.85rem', wordBreak: 'break-all' }}>
                  https://{getTrackingDomain()}/postback?click_id={'{click_id}'}&event={eventForm.event_code}
                </Box>
              </Paper>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenEventModal(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSaveEvent} disabled={!eventForm.event_name || !eventForm.event_code}>
              {editingEvent ? 'Update Event' : 'Create Event'}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Offer URL Modal - Admin only */}
      {!isPartnerRole && (
        <Dialog open={openOfferUrlModal} onClose={() => setOpenOfferUrlModal(false)} maxWidth="sm" fullWidth>
          <DialogTitle>{editingOfferUrl ? 'Edit Offer URL' : 'Add Offer URL'}</DialogTitle>
          <DialogContent>
            <TextField fullWidth label="Name" value={offerUrlForm.name} onChange={e => setOfferUrlForm({...offerUrlForm, name: e.target.value})} sx={{ mt: 2, mb: 2 }} />
            <TextField fullWidth label="URL Template" value={offerUrlForm.url_template} onChange={e => setOfferUrlForm({...offerUrlForm, url_template: e.target.value})} multiline rows={2} helperText="Macros: {uid}, {source}, {click_id}" sx={{ mb: 2 }} />
            <FormControlLabel control={<Switch checked={offerUrlForm.is_default} onChange={e => setOfferUrlForm({...offerUrlForm, is_default: e.target.checked})} />} label="Default URL" />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenOfferUrlModal(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSaveOfferUrl} disabled={!offerUrlForm.name || !offerUrlForm.url_template}>{editingOfferUrl ? 'Update' : 'Create'}</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Creative Modal - Admin only */}
      {!isPartnerRole && (
        <Dialog open={openCreativeModal} onClose={() => setOpenCreativeModal(false)} maxWidth="md" fullWidth>
          <DialogTitle>Add HTML Creative</DialogTitle>
          <DialogContent>
            <TextField 
              fullWidth 
              label="Creative Name" 
              value={creativeForm.name} 
              onChange={e => setCreativeForm({...creativeForm, name: e.target.value})} 
              sx={{ mt: 2, mb: 2 }} 
            />
            <Typography variant="caption" color="textSecondary" sx={{ mb: 1, display: 'block' }}>
              Use {'{tracking_link}'} in your HTML. It will be replaced with the actual tracking link when downloading.
            </Typography>
            <TextField 
              fullWidth 
              multiline 
              rows={15} 
              label="HTML Content" 
              value={creativeForm.content} 
              onChange={e => setCreativeForm({...creativeForm, content: e.target.value})}
              placeholder='<a href="{tracking_link}">Click here</a>'
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenCreativeModal(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSaveCreative} disabled={!creativeForm.name || !creativeForm.content}>Save</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Download Modal */}
      <Dialog open={openDownloadModal} onClose={() => { setOpenDownloadModal(false); setDownloadSourceId(''); }} maxWidth="sm" fullWidth>
        <DialogTitle>Download Creative</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            {isPartnerRole 
              ? 'Your tracking link will be automatically included in the creative.'
              : 'Configure tracking parameters to generate the creative with the correct tracking link.'
            }
          </Typography>
          
          {/* Creative ID - Read only */}
          <TextField
            fullWidth
            label="Creative ID"
            value={downloadCreative?.creative_id || ''}
            disabled
            sx={{ mb: 2 }}
            helperText="This creative will be downloaded"
          />
          
          {!isPartnerRole && (
            <Autocomplete
              fullWidth
              options={[{ partner_id: '', name: 'No Partner (Generic)' }, ...partners.filter(p => selectedPartners.includes(p.partner_id))]}
              getOptionLabel={(option) => option.name || ''}
              value={partners.find(p => p.partner_id === downloadPartner) || { partner_id: '', name: 'No Partner (Generic)' }}
              onChange={(e, newValue) => setDownloadPartner(newValue ? newValue.partner_id : '')}
              renderInput={(params) => <TextField {...params} label="Partner" />}
              sx={{ mb: 2 }}
            />
          )}
          
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Offer URL</InputLabel>
            <Select value={downloadOfferUrl} label="Offer URL" onChange={e => setDownloadOfferUrl(e.target.value)}>
              <MenuItem value="">Default URL</MenuItem>
              {offerUrls.map(u => (
                <MenuItem key={u.offer_url_id} value={u.offer_url_id}>{u.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <TextField
            fullWidth
            label="Source ID (optional)"
            value={downloadSourceId}
            onChange={(e) => setDownloadSourceId(e.target.value)}
            placeholder="e.g., email, facebook, banner1"
            helperText="Custom source identifier for tracking"
            sx={{ mb: 2 }}
          />
          
          {/* Preview tracking link */}
          <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
            <Typography variant="caption" color="textSecondary" fontWeight={600}>Tracking Link Preview:</Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.8rem', wordBreak: 'break-all', mt: 1 }}>
              {(() => {
                let link = `https://${getTrackingDomain()}/track?campaign_id=${id}`;
                if (isPartnerRole) {
                  link += `&partner_id=${user.partner_id}`;
                } else if (downloadPartner) {
                  link += `&partner_id=${downloadPartner}`;
                }
                if (downloadOfferUrl) link += `&offer_url_id=${downloadOfferUrl}`;
                if (downloadCreative?.creative_id) link += `&creative_id=${downloadCreative.creative_id}`;
                if (downloadSourceId) link += `&source=${encodeURIComponent(downloadSourceId)}`;
                return link;
              })()}
            </Typography>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenDownloadModal(false); setDownloadSourceId(''); }}>Cancel</Button>
          {downloadCreative?.type === 'html' && (
            <Button variant="outlined" onClick={handleCopyHtml} sx={{ mr: 1 }}>Copy HTML</Button>
          )}
          <Button variant="contained" onClick={handleDownloadCreative}>Download</Button>
        </DialogActions>
      </Dialog>

      {/* Preview Modal */}
      <Dialog open={openPreviewModal} onClose={() => setOpenPreviewModal(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{previewCreative?.name}</Typography>
            <IconButton onClick={() => setOpenPreviewModal(false)}><Cancel /></IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {previewCreative?.type === 'html' && (
            <Box sx={{ border: '1px solid #ddd', borderRadius: 1, overflow: 'hidden' }}>
              <iframe
                srcDoc={previewCreative.content}
                style={{ width: '100%', height: '500px', border: 'none' }}
                title="Preview"
              />
            </Box>
          )}
          {previewCreative?.type === 'image' && previewCreative.file_path && (
            <Box display="flex" justifyContent="center">
              <Box component="img" src={`${previewCreative.file_path}`} alt={previewCreative.name} sx={{ maxWidth: '100%', maxHeight: '500px' }} />
            </Box>
          )}
        </DialogContent>
      </Dialog>
{/* Partner Payout Modal */}
      <Dialog open={openPayoutModal} onClose={() => setOpenPayoutModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Set Custom Payout - {editingPartnerPayout?.name}</DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mt: 1, mb: 2 }}>
            Leave empty to use campaign default payout (€{parseFloat(formData.payout_percentage || 0).toFixed(2)})
          </Alert>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Payout Type</InputLabel>
                <Select 
                  value={editingPartnerPayout?.custom_payout_type || 'fixed'} 
                  label="Payout Type"
                  onChange={e => setEditingPartnerPayout({...editingPartnerPayout, custom_payout_type: e.target.value})}
                >
                  <MenuItem value="fixed">Fixed Amount (CPA)</MenuItem>
                  <MenuItem value="percentage">Percentage (PRV)</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField 
                fullWidth 
                label={editingPartnerPayout?.custom_payout_type === 'percentage' ? 'Payout (%)' : 'Payout (€)'} 
                type="number"
                value={editingPartnerPayout?.custom_payout || ''} 
                onChange={e => setEditingPartnerPayout({...editingPartnerPayout, custom_payout: e.target.value})}
                helperText={editingPartnerPayout?.custom_payout_type === 'percentage' && editingPartnerPayout?.custom_payout && formData.payout
                  ? `= €${(parseFloat(formData.payout) * parseFloat(editingPartnerPayout.custom_payout) / 100).toFixed(2)}`
                  : 'Leave empty for default'
                }
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPayoutModal(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSavePartnerPayout}>Save Payout</Button>
        </DialogActions>
      </Dialog>

      {/* Edit Creative Modal */}
      <Dialog open={!!editingCreative} onClose={() => setEditingCreative(null)} maxWidth="md" fullWidth>
        <DialogTitle>Edit Creative</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Name"
            value={editingCreative?.name || ""}
            onChange={(e) => setEditingCreative({...editingCreative, name: e.target.value})}
            sx={{ mt: 2, mb: 2 }}
          />
          {editingCreative?.type === "html" && (
            <TextField
              fullWidth
              label="Content"
              multiline
              rows={15}
              value={editingCreative?.content || ""}
              onChange={(e) => setEditingCreative({...editingCreative, content: e.target.value})}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditingCreative(null)}>Cancel</Button>
          <Button variant="contained" onClick={handleEditCreative}>Save</Button>
        </DialogActions>
      </Dialog>


    </Box>
  );
}

export default CampaignDetails;
